import { Icon, IconProps } from './Icon';

export type AlertTriangleProps = IconProps;

export const AlertTriangle = (props: AlertTriangleProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M8 6v2.667m0 2.666h.007m-.93-8.739-5.483 9.472c-.305.525-.457.787-.434 1.003.02.188.118.359.27.47.176.128.48.128 1.087.128h10.966c.607 0 .91 0 1.086-.128a.667.667 0 0 0 .271-.47c.023-.216-.13-.478-.434-1.004l-5.483-9.47c-.303-.524-.454-.786-.652-.874a.667.667 0 0 0-.542 0c-.198.088-.35.35-.652.873Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
